import React from 'react'

const MoneyIcon = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="money-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 200, 50, 1)" />
          <stop offset="100%" stopColor="rgba(255, 150, 50, 1)" />
        </linearGradient>
        <filter id="money-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <circle 
        cx="12" 
        cy="12" 
        r="9" 
        stroke="url(#money-gradient)" 
        strokeWidth="2"
        filter="url(#money-glow)"
      />
      <path 
        d="M12 7V9M12 15V17M9 10H13.5C14.33 10 15 10.67 15 11.5C15 12.33 14.33 13 13.5 13H10.5C9.67 13 9 13.67 9 14.5C9 15.33 9.67 16 10.5 16H15" 
        stroke="url(#money-gradient)" 
        strokeWidth="2" 
        strokeLinecap="round"
        filter="url(#money-glow)"
      />
      <circle cx="8" cy="8" r="1" fill="url(#money-gradient)" opacity="0.5" />
      <circle cx="16" cy="16" r="1" fill="url(#money-gradient)" opacity="0.5" />
    </svg>
  )
}

export default MoneyIcon
